<template>
  <custom-dialog :title="`${typeMapping[activeTab]}`" :showFooter="false">
    <el-row :gutter="20" style="display: flex;">
      <el-col :span="10">
        <el-image :src="getCreativeDetail.src" fit="cover"></el-image>
        <img
          v-if="!getCreativeDetail.isSuitCreatorLevel"
          src="@/assets/upgrade.svg"
          style="width:36px; height:36px; position:absolute; top:8px; left: 228px"
        />
      </el-col>
      <el-col :span="14">
        <el-form size="mini" style="height: 88%;">
          <el-form-item v-show="tabOptions.length > 1">
            <el-tabs v-model="activeTab" type="card" style="margin: 0px;">
              <el-tab-pane
                v-for="tab in tabOptions"
                :key="tab.value"
                :label="tab.label"
                :name="tab.value"
              ></el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item>
            <el-tag
              v-show="getCreativeDetail.features.length"
              v-for="feature in getCreativeDetail.features"
              :key="feature"
              size="small"
              type="danger"
              style="margin-right: 10px;"
            >
              {{ filterOptions.features[feature] }}
            </el-tag>
          </el-form-item>
          <el-form-item>
            <ul class="list-support">
              <li>
                Device :
                <span class="text-support">
                  {{ supportDevice }}
                </span>
              </li>
              <li>
                Format :
                <span class="text-support">
                  {{ supportFormat }}
                </span>
              </li>
            </ul>
          </el-form-item>
          <el-form-item class="table-size">
            <el-table :data="tableData" size="medium" style="width: 100%">
              <el-table-column prop="asset" label="">
                <template slot-scope="{ row }">
                  <div v-if="row.asset === 'Advertiser Icon'" class="center">
                    <div>
                      {{ row.asset }}
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="upload icon at page 'My Advertiser' "
                      placement="top"
                    >
                      <i class="el-icon-info text-support pointer"> </i>
                    </el-tooltip>
                  </div>
                  <div
                    v-else-if="acceptSameRatio && row.asset === 'Image'"
                    class="center"
                  >
                    <div>
                      {{ row.asset }}
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="accept the same ratio"
                      placement="top"
                    >
                      <i class="el-icon-info text-support pointer"> </i>
                    </el-tooltip>
                  </div>
                  <div v-else>
                    {{ row.asset }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="Size"></el-table-column>
              <el-table-column
                prop="quantity"
                label="Quantity"
              ></el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <el-button
          v-if="!getCreativeDetail.isSuitCreatorLevel"
          class="btn btn-form btn-blue btn-footer"
          style="float: right;"
          @click="toPricePage()"
        >
          Upgrade
        </el-button>
        <el-button
          class="btn btn-form btn-pink btn-footer"
          v-else-if="
            CONSTANT.USER_LEVEL_FILTER.MID.includes(userInfo.service.user_level)
          "
          @click.native="
            showDialog({ type: 'creative', row: { _type: activeTab } })
          "
          style="float: right;"
        >
          Start Now
        </el-button>

        <el-button
          class="btn btn-form btn-pink btn-footer"
          v-if="activeTab !== CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST"
          @click.native="demoPage(activeTab)"
          style="float: right;"
        >
          Demo Page
        </el-button>
      </el-col>
    </el-row>
  </custom-dialog>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import CustomDialog from "@/components/base/customDialog";
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      activeTab: this.row._type,
    };
  },
  components: {
    CustomDialog,
  },
  computed: {
    ...mapState({
      visible: (state) => state.isDialogVisible,
      typeInfo: (state) => state.creative.typeInfo,
      typeMapping: (state) => state.creative.typeMapping,
      filterOptions: (state) => state.creative.filterOptions,
      userInfo: (state) => state.user.userInfo,
    }),
    tabOptions() {
      const VideoFormat = this.row._type + "WithOutstream";
      const hasVideoFormat = _.find(
        this.typeInfo,
        (typeInfo) => typeInfo.type === VideoFormat
      );

      let tabOptions = [{ label: "Basic", value: this.row._type }];
      if (hasVideoFormat) {
        tabOptions.push({ label: "With Video", value: VideoFormat });
      }
      this.activeTab = this.row._type;
      return tabOptions;
    },
    getCreativeDetail() {
      return _.find(this.typeInfo, (creative) => {
        return creative.type === this.activeTab;
      });
    },
    supportDevice() {
      return _.map(this.getCreativeDetail.devices, (deviceIndex) =>
        _.startCase(this.filterOptions.devices[deviceIndex])
      ).join(" / ");
    },
    supportFormat() {
      return this.getCreativeDetail.formats.join(" / ");
    },
    tableData() {
      return _.map(this.getCreativeDetail.sizes, (size, asset) => {
        asset = asset.replace("_", " ");
        let sizeQuantity = size.split("*");
        sizeQuantity[0] = sizeQuantity[0].replaceAll("x", " x ");
        sizeQuantity[0] = sizeQuantity[0].replace("/", " / ");
        return {
          asset: asset,
          size: sizeQuantity[0].replace(/\w+ \w+/g, _.startCase),
          quantity: sizeQuantity[1],
        };
      });
    },
    acceptSameRatio() {
      let accept = ["parallaxScrolling"];
      return accept.includes(this.row._type);
    },
  },
  methods: {
    ...mapActions({
      showDialog: "showDialog",
    }),
    demoPage(activeTab) {
      try {
        const route = this.$router.resolve({
          path: `/preview/demo?_type=${activeTab}`,
        });
        const win = window.open(route.href, "_blank");
        win.onload = () => {
          win.focus();
        };
      } catch (e) {
        console.log(e);
      }
    },
    toPricePage() {
      this.$router.push("/pricing");
    },
  },
  created() {
    this.tableData;
  },
  watch: {
    visible(newVisible) {
      if (newVisible) {
        this.tableData;
      }
    },
    activeTab() {
      this.tableData;
    },
  },
};
</script>

<style lang="sass">
.list-support
  list-style: none
  li
    &::before
      content: "• "
      font-size: 22px
      color: $color-pink
      position: relative
      top: 3px

.text-support
  color: $color-pink
  padding-left: 10px
  &.pointer
    cursor: pointer
.center
  display: flex
  justify-self: center
  align-items: center
</style>
